var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgColar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.55 74.55",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #171954;\n      }\n\n      .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-3 {\n        stroke: #171954;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m52.84,56.9c-.2,1.16-.4,2.36-1.39,3.35-.86.86-2.04,1.39-3.35,1.39h-27.85c-2.62,0-4.74-2.12-4.74-4.74v-27.85c0-2.62,2.12-4.74,4.74-4.74"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.09,
    y: 17.37,
    width: 12.83,
    height: 1.56
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 37.09,
    y: 12.03,
    width: 12.83,
    height: 1.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.09,22.93v-5.56h-2.72c-1.43,0-2.59,1.16-2.59,2.59v26.27c0,1.43,1.16,2.59,2.59,2.59h26.27c1.43,0,2.59-1.16,2.59-2.59v-26.27c0-1.43-1.16-2.59-2.59-2.59h-2.72v5.56h-20.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.64,13.59h-2.72v3.77h2.72c1.43,0,2.59,1.16,2.59,2.59v26.27c0,1.43-1.16,2.59-2.59,2.59h-26.27c-1.43,0-2.59-1.16-2.59-2.59v-26.27c0-1.43,1.16-2.59,2.59-2.59h2.72v-3.77h-2.72c-3.51,0-6.36,2.85-6.36,6.36v26.27c0,3.51,2.85,6.36,6.36,6.36h26.27c3.51,0,6.36-2.85,6.36-6.36v-26.27c0-3.51-2.85-6.36-6.36-6.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.09,22.93h20.83v-14.89h-20.83v14.89Zm4-10.89h12.83v6.89h-12.83v-6.89Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgColar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/COLAR.cde68777c9fd9daf7bb37affe4ff5df8.svg";